import { EastBayChallengePage } from "../components/ebrpgoal.component";
export function GoalsPage(props: any) {
  return <EastBayChallengePage />;
}
